<div class="iss-container iss-breadcrumbs" *ngIf="visible">
  <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
    <ng-container [ngSwitch]="last">
      <span *ngSwitchCase="true" class="iss-breadcrumbs-item">{{ breadcrumb.title | translate }}</span>
      <ng-container *ngSwitchCase="false">
        <a class="iss-breadcrumbs-item" [routerLink]="breadcrumb.commands">{{ breadcrumb.title | translate }}</a>
        <span class="iss-breadcrumbs-separator"></span>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
